module.exports = __webpack_public_path__ + "static/media/girl-two.0a2a89bb.jpg";